import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _styled from "styled-components";
var _excluded = ["size", "rotate", "css", "fillColor"];
// Automatically generated from SVG file with `npm run pixo`
// Do not modify manually

import React from "react";
import BaseSvg from "../BaseSvg";
var ExclamationMarkDiamondFilledIcon = function ExclamationMarkDiamondFilledIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "1.5em" : _ref$size,
    rotate = _ref.rotate,
    css = _ref.css,
    _ref$fillColor = _ref.fillColor,
    fillColor = _ref$fillColor === void 0 ? "currentColor" : _ref$fillColor,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledBaseSvg, _extends({}, rest, {
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    $fillColor: fillColor,
    rotate: rotate,
    "aria-hidden": "true",
    focusable: "false",
    $_css: css
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 1 11 11.05L12 23 1 12.05z M11 6v9h2V6zm0 10.5v2h2v-2z"
  }));
};
export default ExclamationMarkDiamondFilledIcon;
var _StyledBaseSvg = _styled(BaseSvg).withConfig({
  displayName: "ExclamationMarkDiamondFilledIcon___StyledBaseSvg",
  componentId: "sc-1wejt88-0"
})(["", ""], function (p) {
  return p.$_css;
});